/**
 * 파크웨이브 디자인 토큰 — Ant ConfigProvider·CSS 변수·컴포넌트의 단일 소스.
 * 마케팅(틸)과 콘솔(네이비)을 한 팔레트로 맞춘다.
 */
export const PW = {
  color: {
    navy: '#0b1220',
    ink: '#0f172a',
    muted: '#475569',
    faint: '#64748b',
    primary: '#0e7490',
    primaryHover: '#155e75',
    primaryActive: '#164e63',
    primarySoft: '#ecfeff',
    cyan: '#22d3ee',
    info: '#0369a1',
    success: '#15803d',
    warning: '#b45309',
    error: '#b91c1c',
    canvas: '#e8edf5',
    surface: '#f8fafc',
    card: '#ffffff',
    line: '#e2e8f0',
    lineStrong: '#cbd5e1',
    sider: '#0b1220',
    onDark: '#f8fafc',
    onDarkMuted: 'rgba(248, 250, 252, 0.78)',
  },
  radius: {
    sm: 6,
    md: 10,
    lg: 14,
  },
  shadow: {
    header: '0 1px 0 rgba(15, 23, 42, 0.06)',
    card: '0 8px 28px rgba(15, 23, 42, 0.06)',
  },
  font: {
    sans: `-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Apple SD Gothic Neo', 'Noto Sans KR', 'Malgun Gothic', sans-serif`,
    code: `ui-monospace, 'SF Mono', 'Cascadia Code', Consolas, 'Liberation Mono', monospace`,
  },
} as const;

export type PwColor = (typeof PW.color)[keyof typeof PW.color];
